import styled from 'styled-components';
import MiniText from 'js/components/core/MiniText';

export default styled(MiniText)`
  text-align: center;
`;
